module.exports = __webpack_public_path__ + "img/decor-tire-size-320x108.416fa4e5.webp";